export default __webpack_public_path__ + "static/media/zoomin-white.d70533cd.svg";